import { render, staticRenderFns } from "./xinliceping-list.vue?vue&type=template&id=62cc805a&scoped=true&"
import script from "./xinliceping-list.vue?vue&type=script&lang=ts&"
export * from "./xinliceping-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62cc805a",
  null
  
)

export default component.exports